import { css, cx } from "@emotion/css";
import { Modal as MuiModal } from "@mui/material";
import React from "react";
export interface ModalProps {
    open: boolean;
    children: React.ReactElement;
    className?: string;
}
export function Modal({ open, className, children }: ModalProps) {
    return (<MuiModal open={open} className={cx(styles, className)}>
            {children}
        </MuiModal>);
}
const styles = css({
    "&&": {
        zIndex: "1199", // 1200 or more makes the modal appear above the drawer when it shouldn't
    },
});
